/*
 * WARNING: This file was automatically generated.
 * Changes must be made to the package.templateroot, or they will be lost!
 */
export enum IMarketingType {
  Library = 'library',
  Favorites = 'favorites',
  LiveBike = 'live-bike',
  LiveTreadmill = 'live-treadmill',
  LiveStrength = 'live-strength',
  UpgradeExpired = 'upgrade-expired',
  UpgradeAnonymous = 'upgrade-anonymous',
  Custom = 'custom',
}
